import { IqueryForExecutionSummaryHistorical } from "@/services/ActionSummaryTableSERVICES";
import { SideBarDef } from "ag-grid-community";
import featureFlagStore from "@/store/featureFlagStore";

// LQC-1301 (experiment) — custom icon for the Trade Settings tool-panel tab.
// AG Grid looks up the tool panel's `iconKey` in the grid `icons` map, so the
// gear (matching `settingsIcon` in SVGIcons) renders on the left rail. Passed to
// AgGridReact via the `icons` prop. `currentColor` lets it inherit the rail's
// active/inactive button colour.
const tradeSettingsIconSvg =
  // Thinner stroke + reduced opacity so the cog reads lighter than the other
  // rail icons (matches the muted weight the other built-in glyphs have).
  '<svg fill="none" stroke="currentColor" opacity="0.65" width="18" height="18" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M9.99376 3.97917C10.0875 3.41458 10.5771 3 11.15 3H13.851C14.424 3 14.9135 3.41458 15.0073 3.97917L15.2292 5.31354C15.2948 5.70313 15.5552 6.02812 15.901 6.21979C15.9781 6.26146 16.0542 6.30625 16.1302 6.35208C16.4688 6.55625 16.8802 6.61979 17.25 6.48125L18.5177 6.00625C18.7775 5.90855 19.0635 5.90623 19.3249 5.9997C19.5862 6.09317 19.8059 6.27637 19.9448 6.51667L21.2948 8.85729C21.4334 9.09761 21.4822 9.3793 21.4327 9.65226C21.3831 9.92521 21.2382 10.1717 21.024 10.3479L19.9792 11.2094C19.674 11.4604 19.5229 11.8479 19.5313 12.2427C19.5327 12.3312 19.5327 12.4198 19.5313 12.5083C19.5229 12.9021 19.674 13.2896 19.9792 13.5406L21.025 14.4021C21.4667 14.7667 21.5813 15.3969 21.2958 15.8917L19.9438 18.2323C19.8051 18.4725 19.5856 18.6558 19.3245 18.7494C19.0634 18.8431 18.7775 18.8411 18.5177 18.7437L17.25 18.2688C16.8802 18.1302 16.4688 18.1937 16.1292 18.3979C16.0537 18.4439 15.9773 18.4883 15.9 18.5312C15.5552 18.7219 15.2948 19.0469 15.2292 19.4365L15.0073 20.7708C14.9135 21.3365 14.424 21.75 13.851 21.75H11.149C10.576 21.75 10.0875 21.3354 9.99271 20.7708L9.77084 19.4365C9.70626 19.0469 9.44584 18.7219 9.10001 18.5302C9.02276 18.4876 8.94636 18.4435 8.87084 18.3979C8.5323 18.1937 8.12084 18.1302 7.75001 18.2688L6.4823 18.7437C6.22264 18.8412 5.93684 18.8433 5.67573 18.7499C5.41462 18.6564 5.19512 18.4734 5.05626 18.2333L3.70521 15.8927C3.56661 15.6524 3.51776 15.3707 3.56736 15.0977C3.61695 14.8248 3.76177 14.5783 3.97605 14.4021L5.02188 13.5406C5.32605 13.2906 5.47709 12.9021 5.4698 12.5083C5.46817 12.4198 5.46817 12.3312 5.4698 12.2427C5.47709 11.8469 5.32605 11.4604 5.02188 11.2094L3.97605 10.3479C3.76203 10.1718 3.61737 9.92545 3.56779 9.65273C3.5182 9.38001 3.5669 9.09855 3.70521 8.85833L5.05626 6.51771C5.19499 6.27723 5.4146 6.09381 5.67596 6.00014C5.93731 5.90647 6.22343 5.90864 6.48334 6.00625L7.75001 6.48125C8.12084 6.61979 8.5323 6.55625 8.87084 6.35208C8.94584 6.30625 9.02292 6.2625 9.10001 6.21875C9.44584 6.02813 9.70626 5.70313 9.77084 5.31354L9.99376 3.97917Z" stroke="currentColor" stroke-width="1.3"/>' +
  '<path d="M15.625 12.5C15.625 13.3288 15.2958 14.1237 14.7097 14.7097C14.1237 15.2958 13.3288 15.625 12.5 15.625C11.6712 15.625 10.8763 15.2958 10.2903 14.7097C9.70424 14.1237 9.375 13.3288 9.375 12.5C9.375 11.6712 9.70424 10.8763 10.2903 10.2903C10.8763 9.70424 11.6712 9.375 12.5 9.375C13.3288 9.375 14.1237 9.70424 14.7097 10.2903C15.2958 10.8763 15.625 11.6712 15.625 12.5Z" stroke="currentColor" stroke-width="1.3"/>' +
  "</svg>";

export function getActionSummarySidebarIcons(): {
  [key: string]: string | Function;
} {
  return featureFlagStore.getState().tradeSettingsSidebarAndCog
    ? { tradeSettings: tradeSettingsIconSvg }
    : {};
}

export function actionSummarySidebar({
  historicTradeDataForMainTable,
  setHistoricTradeDataForMainTable,
  isMiniTable,
  cryptoID,
}: {
  historicTradeDataForMainTable: IqueryForExecutionSummaryHistorical;
  setHistoricTradeDataForMainTable: Function;
  // LQC-1301 — forwarded to the Trade Settings tool panel so it can bind to the
  // owning trade tile's trade (mini table) instead of the shared global
  // selection. Both are stable for the widget's lifetime.
  isMiniTable?: boolean;
  cryptoID?: string;
}): SideBarDef {
  const isTradeSettingsEnabled =
    featureFlagStore.getState().tradeSettingsSidebarAndCog;

  return {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        minWidth: 225,
        maxWidth: 225,
        width: 300,
        toolPanelParams: {
          suppressPivotMode: true,
          suppressRowGroups: true,
          suppressValues: true,
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
        minWidth: 180,
        maxWidth: 400,
        width: 300,
      },
      {
        id: "historicalSearch",
        labelDefault: "Historical Search",
        labelKey: "historicalSearch",
        iconKey: "chart",
        toolPanel: "customConfigsToolPanel",
        toolPanelParams: {
          historicTradeDataForMainTable,
          setHistoricTradeDataForMainTable,
        },
        // LQC-2575 - a matched min and max is what removes AG Grid's resize handle,
        // so this panel could not be widened. Opens at the same 300 as before; the
        // fields inside are fluid so the extra width goes to the inputs.
        minWidth: 250,
        maxWidth: 450,
        width: 350,
      },
      ...(isTradeSettingsEnabled
        ? [
            {
              // LQC-1301 (experiment) — Trade Settings slide-in. Custom gear icon is
              // registered via the AgGridReact `icons` prop (key: "tradeSettings").
              id: "tradeSettings",
              labelDefault: "Trade Settings",
              labelKey: "tradeSettings",
              iconKey: "tradeSettings",
              toolPanel: "tradeSettingsToolPanel",
              toolPanelParams: {
                isMiniTable,
                cryptoID,
              },
              // Condensed layout (Auto Affirm + a per-CP grid: CP / Side /
              // Direction / Iceberg / Advise Comp / Advise Cover / Cover Spread)
              // and the read-only RP view. minWidth allows shrinking well below
              // the previous 360 floor - the grid scrolls horizontally below it.
              //
              // Widths are driven by COLUMN_FLOORS_BY_FONT_SIZE in
              // condensedGridColumnsHelper.ts. Usable content is the panel less
              // ~30px (the container's m-2/p-1 plus the vertical scrollbar), and
              // at medium the row needs 342px (Awarded onwards, no Side or
              // Direction), 460px (+ Side) or 578px (+ Direction, i.e. a Two-Way
              // CP). So the default opens at 500 to cover the first two without a
              // scrollbar (LQC-2271), and the max reaches the third.
              minWidth: 220,
              maxWidth: 640,
              width: 500,
            },
          ]
        : []),
    ],
    position: `left`,
  };
}
